import BaseItem, { Rarity } from './base_item';

export default class Hammer extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "hammer.png");
    }

    get canBeBurnedRightNow() {
        return this.isAvailable && !game.gameState.badKarma;
    }


    //this is width/height of collision box (attached to bottom)
    static get width() { return 27;}
    static get height() { return 18;}

    static get mass() { return 10;}
    static get rarity() { return Rarity.RARE; }
    static get electronic() { return false; }

    static get type() { return 'hammer'}
    static get label() { return 'suspiciously heavy hammer'}
    static get description() { return `This hammer is quite heavy for its size. There's a faded label: 'M.de in A..g.rd.'`}
}


// WEBPACK FOOTER //
// ./src/objects/items/hammer.js